import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Mail, Sparkles } from 'lucide-react';
import JobForm from '../components/JobForm';
import CvUploadSection from '../components/CvUploadSection';
import { submitJob } from '../services/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Alert, AlertDescription } from '../components/ui/alert';

function HomePage() {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    try {
      setError(null);
      
      const response = await submitJob({
        ...formData,
        data_dir: './data',
        model: 'BAAI/bge-large-en-v1.5'
      });
      
      navigate(`/processing/${response.job_id}`);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Failed to start processing');
    }
  };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <header className="bg-gradient-to-r from-emerald-600 to-teal-600 text-white shadow-lg">
        <div className="container mx-auto px-4 py-8">
          <div className="flex items-center justify-center gap-3">
            <Sparkles className="h-8 w-8" />
            <h1 className="text-3xl font-bold tracking-tight">Resume Screener</h1>
          </div>
          <p className="text-center mt-2 text-emerald-100">AI-Powered CV Ranking System</p>
        </div>
      </header>
      
      {/* Main Content */}
      <main className="container mx-auto px-4 py-8 max-w-4xl">
        <CvUploadSection />

        <Card className="shadow-xl border-0 animate-fade-in">
          <CardHeader className="space-y-1 pb-4">
            <div className="flex items-center gap-2">
              <FileText className="h-5 w-5 text-emerald-600" />
              <CardTitle className="text-xl">Job Description</CardTitle>
            </div>
            <CardDescription>
              Fill in the job details below.
            </CardDescription>
          </CardHeader>
          
          <CardContent>
            {error && (
              <Alert variant="destructive" className="mb-6">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}
            
            <JobForm onSubmit={handleSubmit} />
          </CardContent>
        </Card>
        
        {/* Quick Actions */}
        <div className="mt-6 flex justify-center">
          <Button 
            variant="outline"
            size="lg"
            onClick={() => navigate('/email')}
            className="gap-2"
          >
            <Mail className="h-4 w-4" />
            Send Emails to Candidates
          </Button>
        </div>
      </main>
    </div>
  );
}

export default HomePage;
